// extracted by mini-css-extract-plugin
export var brand = "_6h-9";
export var compact = "_6h-6";
export var extraSmall = "_6h-7";
export var icon = "_6h-0";
export var large = "_6h-4";
export var light = "_6h-1";
export var medium = "_6h-5";
export var outline = "_6h-b";
export var primaryDark = "_6h-a";
export var primaryLight = "_6h-8";
export var primaryModern = "_6h-c";
export var success = "_6h-2";
export var successSolid = "_6h-3";